// Dependencies
import React from "react";
import { useIntl } from "react-intl";
import { useOti } from "../../OtiContext";

// Components
import ScrollBox from "../SharedComponents/ScrollBox";

import makeStyles from "@mui/styles/makeStyles";
import { Grid, Button } from "@mui/material";
import ProfilePageForm from "./ProfilePageForm";
import ProfilePageAvatar from "./ProfilePageAvatar";
import { getStorage } from "firebase/storage";
import { useFirebaseApp, StorageProvider } from "reactfire";

//Styles
const useStyles = makeStyles((theme) => ({
  profileContainer: {
    paddingBlock: theme.spacing(9)
  },
  avatarSection: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  avatarImg: {
    marginBlockStart: theme.spacing(4),
    marginBlockEnd: theme.spacing(7.5),
    borderRadius: 100,
    width: 178
  },
  input: {
    display: "none"
  }
}));

export default function ProfilePage() {
  //Hooks
  const classes = useStyles();
  const reactFirebaseApp = useFirebaseApp();
  const storage = getStorage(reactFirebaseApp);
  const intl = useIntl();
  const { openCookiePreferences } = useOti();

  //Ephemeral state

  //Redux state

  //Variables

  //Behavior
  const handleCookieDialog = () => {
    if (openCookiePreferences) {
      openCookiePreferences();
    } else {
      console.warn("OneTrust service function not available yet.");
    }
  };

  // Render
  return (
    <ScrollBox>
      <Grid className={classes.profileContainer} container spacing={2}>
        <Grid item xs={2}></Grid>
        <Grid
          item
          xs={2}
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center"
          }}>
          <StorageProvider sdk={storage}>
            <ProfilePageAvatar />
          </StorageProvider>
          <Button onClick={handleCookieDialog} sx={{ marginTop: "24px" }}>
            {intl.formatMessage({
              id: "profile.triggerCookiesDialog",
              defaultMessage: "Change cookies settings"
            })}
          </Button>
        </Grid>
        <Grid item xs={1}></Grid>
        <Grid item xs={5}>
          <ProfilePageForm />
        </Grid>
        <Grid item xs={2}></Grid>
      </Grid>
    </ScrollBox>
  );
}
